
import { Component, Vue, Prop } from "vue-property-decorator";
import TeacherItem from "./components/TeacherItem.vue";
import { teacherList } from "@/apis/home";
import Pagination from "@/components/pagination.vue";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
@Component({
  components: {
    TeacherItem,
    Pagination,
    Breadcrumb
  }
})
export default class Teacher extends Vue {
  total = 1;
  page = 1;
  per_page = 8;
  list: any = [];
  index: any = 0;
  List = [{ title: "光华师资", url: "" }];
  created() {
    if (this.$route.query.index) {
      this.index = this.$route.query.index;
    }
    this.teacherList();
  }
  handlePageChange(val: any) {
    this.page = val.page;
    this.teacherList();
  }
  async teacherList() {
    const { data, total } = await teacherList({
      action: "list",
      type: 2,
      page: this.page,
      per_page: this.per_page
    });
    this.list = data;
    this.total = total;
    if (this.index > 0) {
      this.$nextTick(() => {
        window.location.hash = "#li" + this.index;
      });
    }
  }
  clickTeacher(item: any) {
    this.$router.push(`/teacher-detail?id=${item.id}`);
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "光华介绍，光华师资，光华动态，客户案例，效果看得见，"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业培训咨询数字化转型，找光华，企业培训咨询数字化转型 |，找光华，服务一万家企业绩效飞轮*应用实践，帮助一万家企业BLM科学经营T系统落地，到2035年，赋能陪跑企业合计GDP超一万亿规模，用科学经营助推企业高质量发展讲师说明：董权、霍振先、潘亦藩、蔡毅臣、杨波、方永飞 所有老师的名字动态说明：动态标题，客户案例说明：客户案例标题"
    );
    document.head.appendChild(metaTag2);
  }
}
